import {
  Box,
  Button,
  Checkbox,
  ClickAwayListener,
  Collapse,
  FormControlLabel,
  FormGroup,
  IconButton,
  Input,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
  withStyles
} from "@material-ui/core";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  activeAlertTargetState,
  coPilotDetailTargetState,
  coPilotDetailViewState,
  coPilotFocusTargetState,
  coPiTooltipSettings,
  csTargetSelectState,
  csTargetState,
  navLogTargetState
} from "../../store/CopilotState";
import { MAP_ID_COPILOT, MAP_ID_FLIGHTPLAN_LIST, mapContentsVisibleWithID } from "../../store/MapContentsState";
import MailIcon from '@material-ui/icons/Mail';
import noImage from "../../images/contents/map/copilot/no_image.jpg";
import { useTranslation } from "react-i18next";
import {
  MESSAGE_WIDGET,
  messageAircraftIds,
  messageSelectedGroupState,
  messageWidgetVisibleState
} from "../../store/MessageState";
import clsx from "clsx";
import { OnClickAnchor } from "../../parts/OnClickAnchor";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import { flightPlanListViewVisibleState } from "../../store/FlightPlanListViewState";
import { ReactComponent as Heli } from "../../images/contents/map/copilot/heli_blue.svg";
import { ReactComponent as Cessna } from "../../images/contents/map/copilot/cessna_blue.svg";
import { ReactComponent as Navi } from "../../images/contents/map/copilot/navi_blue.svg";
import { ReactComponent as OtherCompany } from "../../images/contents/map/copilot/other_blue.svg";
import { ReactComponent as Filter } from "../../images/contents/map/copilot/filter.svg";
import { deepCopy, formatLatDM, formatLonDM, formatTimeZoneDate, formatTimeZoneStr } from "../../utils/FPEUtils";
import RoomIcon from '@material-ui/icons/Room';
import AssignmentIcon from '@material-ui/icons/Assignment';
import CloseIcon from '@material-ui/icons/Close';
import { doPlanDataUpdateState, planDataRevisionState, useFlightPlanForCopilotList } from "../../store/FlightPlanState";
import useEffectSkipFirst from "../../hooks/useEffectSkipFirst";
import HistoryIcon from '@material-ui/icons/History';
import { ReactComponent as ImageCrossSection } from '../../images/flightplan/crosssection.svg';
import { useLayoutState } from "../../store/LayoutState";
import { audioContextState, coPilotDisplaySettingsSelector } from "../../store/CopilotDisplaySettingsState";
import LaunchIcon from '@material-ui/icons/Launch';
import {
  coPiAlertState,
  coPiListCheckedState,
  coPiListDataState,
  coPiSourceCheckedState
} from "../../store/CopilotListState";
import CoPiListObserver from "./CopiListObserver";
import { timeZoneSelector } from "../../store/TimeZoneState";
import { useCrossSectionData } from "../../store/CrossSectionDataState";
import { ReactComponent as PlanWhite } from "../../images/contents/map/copilot/plan_white.svg";
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import FilterListIcon from '@material-ui/icons/FilterList';
import { useAlert } from "../../hooks/useAlert";
import { csGradationState } from "../../store/CsSettingState";
import { csAdjustVerticalZoomWithRouteSelector } from "../../store/CsAdjustVerticalZoomWithRouteState";
import GuideLink from "../GuideLink";
import { userState } from "../../store/UserState";
import MuiPagination from "@material-ui/lab/Pagination";
import { Search } from "@material-ui/icons";
import { alpha } from "@material-ui/core/styles";
import { ReactComponent as VolumeOnIcon } from "../../images/contents/map/copilot/volume_on.svg"
import { ReactComponent as VolumeOffIcon } from "../../images/contents/map/copilot/volume_off.svg"
import { TinySwitch } from "../../parts/TinySwitch";
import { useLinkableSourceList } from "../../store/AircraftSettingState";
import { disabledContentsWithID } from "../../store/DisabledContentsState";

const useStyles = makeStyles(theme => ({
  coPilotList: {
    position: "absolute",
    bottom: 12,
    left: 0,
    zIndex: 1,
    background: "#FFFFFF"
  },
  tableContainer: {
    maxHeight: 483,
    overflowX: "hidden"
  },
  infoCell: {
    display: "flex",
    alignItems: "center"
  },
  image: {
    width: 90,
    height: 60,
    objectFit: 'cover'
  },
  imageBox: {
    display: "flex",
    justifyContent: "center",
    width: 92,
    height: 60,
    borderLeft: '1px solid rgb(214,214,214)',
    borderRight: '1px solid rgb(214,214,214)',
    boxSizing: 'border-box'
  },
  textCell: {
    fontSize: 13
  },
  iconHeli: {
    height: 14,
    width: 14,
    position: 'relative',
    top: 2
  },
  iconCessna: {
    height: 16,
    width: 16,
    position: 'relative',
    top: 3
  },
  iconNavi: {
    height: 13,
    width: 13,
    position: 'relative',
    top: 1
  },
  iconOtherCompany: {
    height: 18,
    width: 18,
    position: 'relative',
    top: 4,
    right: 2
  },
  iconCircle: {
    height: 9,
    width: 9,
    borderRadius: 50,
    border: "solid 2px #0000FF",
    backgroundColor: "#0000FF"
  },
  icon: {
    marginRight: 3
  },
  buttonIcon: {
    marginRight: 10
  },
  clickableButton: {
    cursor: "pointer"
  },
  listItemTextChild: {
    display: 'flex',
    fontSize: 13
  },
  listItemText: {
    marginTop: 0,
    marginBottom: 0
  },
  listItem: {
    padding: 0
  },
  displayFlex: {
    display: 'flex'
  },
  detailAirCraftImgBox: {
    width: 120
  },
  detailAirCraftImg: {
    width: '100%'
  },
  detailTitle: {
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  detailBox: {
    backgroundColor: '#5A5A5A',
    color: '#FFFFFF',
    fontSize: 13,
    padding: 5
  },
  detailSection: {
    paddingBottom: 5,
    textAlign: 'left'
  },
  spaceBetween: {
    justifyContent: 'space-between'
  },
  detailDepArrInner: {
    width: '100%',
    border: "solid 1px #000000",
    padding: 5,
    backgroundColor: '#FFFFFF',
    color: '#000000',
    justifyContent: 'space-between'
  },
  closeIcon: {
    cursor: 'pointer'
  },
  itemName: {
    width: 66
  },
  detailSeparator: {
    width: 10
  },
  detailAircraftName: {
    marginRight: 10
  },
  csButtonIcon: {
    width: 14,
    height: 14
  },
  defaultCsButtonIcon: {
    fill: '#000000'
  },
  primaryCsButtonIcon: {
    fill: '#FFFFFF'
  },
  coPiFilter: {
    paddingLeft: 10,
    borderBottom: 'solid 1px #000000',
    display: 'flex',
    alignItems: 'center'
  },
  inputLabel: {
    fontSize: 12
  },
  filterCheckBox: {
    paddingRight: 5
  },
  buttonIconDisabled: {
    opacity: 0.5
  },
  planDetail: {
    justifyContent: 'right',
    cursor: 'pointer',
    textDecoration: 'underline'
  },
  buttonPosition: {
    justifyContent: 'space-around'
  },
  groupFilterButton: {
    padding: 5
  },
  groupFilterList: {
    position: 'absolute',
    backgroundColor: '#FFFFFF',
    border: 'solid 1px',
    width: 'max-content',
    overflowY: 'auto',
    top: 26,
    left: 360,
    bottom: 0,
    height: 'fit-content',
    maxHeight: 'calc(100% - 26px)'
  },
  displayNone: {
    display: 'none'
  },
  planWhiteIcon: {
    color: '#000000'
  },
  alertEnabled: {
    color: '#000000'
  },
  positionDataSection: {
    paddingLeft: 8
  },
  positionData: {
    padding: '4px 0px 0px 8px'
  },
  aircraftData: {
    paddingLeft: 8
  },
  sourceName: {
    minWidth: 66
  },
  remarks: {
    width: 266,
    overflowWrap: "break-word"
  },
  showSwitch: {
    display: "flex"
  },
  showSwitchLabel: {
    marginLeft: 5
  },
}));

const DEFAULT_FILTER_TARGET = {
  all: true,
  other: true,
  heli: true,
  cessna: true,
  navi: true,
  otherCompany: true
}

const DEFAULT_FILTER_DISABLED = {
  heli: true,
  cessna: true,
  navi: true,
  otherCompany: true,
  other: true
}

const TABLE_ROW_ODD_CLASS_NAME = 'coPi-list-table-row-odd';
const TABLE_ROW_GRAY_CLASS_NAME = 'coPi-list-table-row-gray';
const TABLE_ROW_ALERT_CLASS_NAME = 'coPi-list-table-row-alert';
const TABLE_ROW_ALERT_ANIME_CLASS_NAME = 'coPi-list-table-row-alert-anime';

const RINGING_TIME = 2 * 60 * 1000;

let gain;
let dry;
let wet;
let feedback;
let delay;
const ALERT_TYPE_DEFAULT = 'default';
const ALERT_SOUND_SETTINGS = {
  default: {
    gain: 0.9,
    dry: 0.65,
    wet: 0.6,
    feedback: 0.1,
    delay: 0.18,
    type: 'sine',
    frequency: 1110,
    stopTiming: 0.06,
    interval: 2300
  }
}

const ID_ALL = '0';
const ID_HELI = '6';
const ID_CESSNA = '7';
const ID_NAVI = '8';
const ID_OTHER_COMPANY = '9';
const ID_OTHER = '5';

const CoPilotList = memo(()=> {

  const {t} = useTranslation();
  const classes = useStyles();
  const coPilotVisible = useRecoilValue(mapContentsVisibleWithID(MAP_ID_COPILOT));
  // 折りたたみの状態
  const [isMinimum, setMinimum] = useState(false);
  // 折りたたみ/展開時の横幅
  const MAX_WIDTH = 360;
  const MIN_WIDTH = 230;
  const [boxWidth, setBoxWidth] = useState(isMinimum ? MIN_WIDTH : MAX_WIDTH);
  // 詳細画面の表示/非表示
  const [coPiDetailViewState, setCoPiDetailViewState] = useRecoilState(coPilotDetailViewState);
  // 詳細画面の表示対象
  const detailTargetId = useRecoilValue(coPilotDetailTargetState);
  // 別Windowのインスタンス管理
  const windowObj = useRef();
  // Flight Planボタン押下をFlight Plan Panelに通知する
  const {flightPlanList, setDetail, editState} = useFlightPlanForCopilotList();
  const setFlightPlanListVisible = useSetRecoilState(mapContentsVisibleWithID(MAP_ID_FLIGHTPLAN_LIST));
  const setFlightPlanListViewVisible = useSetRecoilState(flightPlanListViewVisibleState);
  const [waitFlightPlanId, setWaitFlightPlanId] = useState();
  const {showWarning} = useAlert();
  const setDoPlanDataUpdateState = useSetRecoilState(doPlanDataUpdateState);
  const planDataRevision = useRecoilValue(planDataRevisionState);
  const [localRevision, setLocalRevision] = useState(planDataRevision);

  useEffect(() => {
    window.addEventListener('beforeunload', () => {
      if (windowObj.current) {
        windowObj.current.close();
      }
    });
  });

  // 詳細画面に表示切り替え
  useEffectSkipFirst(() => {
    if(!detailTargetId) return;
    setCoPiDetailViewState(true);
    setMinimum(false);
  }, detailTargetId);

  // 折りたたみ/展開切り替え
  const arrowClickHandler = () => {
    setMinimum(!isMinimum);
    if (isMinimum) {
      setBoxWidth(MAX_WIDTH);
    } else {
      setBoxWidth(MIN_WIDTH);
    }
  }

  const openTabHandler = () => {
    windowObj.current = window.open('#coPiList','coPiListTabWindow');
  }

  const setDetailWithSearchPlan = useCallback((id) => {
    const plan = flightPlanList.find(plan => plan.flightPlanId === id);
    if (!plan) {
      showWarning(t('Flight plan did not find'), {timeout: 3000});
    } else {
      setDetail(plan);
    }
  }, [flightPlanList, showWarning, setDetail, t]);

  useEffect(() => {
    if (waitFlightPlanId && localRevision < planDataRevision) {
      setDetailWithSearchPlan(waitFlightPlanId);
      setWaitFlightPlanId(null);
    }
  }, [waitFlightPlanId, localRevision, planDataRevision, setDetailWithSearchPlan, setWaitFlightPlanId]);

  const planClickHandler = useCallback((event, row) => {
    if (row.is_other_org || !row.flight_plan.find(p => p.is_current_plan)) {
      return;
    }

    if (editState.editing) {
      showWarning(t('Cannot switch while editing plan'), {timeout:3000});
      return;
    }

    setLocalRevision(planDataRevision);
    setFlightPlanListVisible(true);
    setFlightPlanListViewVisible(true);
    setDoPlanDataUpdateState(true);

    setWaitFlightPlanId(row.flight_plan.find(p => p.is_current_plan).flightplan_id);
    event.stopPropagation();
    // eslint-disable-next-line
  },[editState.editing, planDataRevision]);

  return (
    <>
      {
        coPilotVisible && <><CoPiListObserver/></>
      }
      <RingAlert/>
      <div style={{display: coPilotVisible ? "block": "none"}}>
        <div className={clsx("widget-box", "dark-color", classes.coPilotList)} style={{width: `${boxWidth}px`}}>
          <div className={clsx("widget-header")}>
            <h4>{'Flight Watch'}</h4>
            {
              !isMinimum &&
              <div className="widget-guid-link">
                <GuideLink id={MAP_ID_COPILOT}/>
              </div>
            }
            <div className="widget-toolbar">
              <OnClickAnchor onClick={openTabHandler}>
                <Tooltip title="Another Tab" arrow>
                  <LaunchIcon/>
                </Tooltip>
              </OnClickAnchor>
              <OnClickAnchor onClick={arrowClickHandler} className="close-anchor">
                {!isMinimum && <Tooltip title="Minimize" arrow >
                  <ArrowDropDownIcon/>
                </Tooltip>}
                {isMinimum && <Tooltip title="Maximize" arrow >
                  <ArrowDropUpIcon/>
                </Tooltip>}
              </OnClickAnchor>
            </div>
          </div>
          <Collapse in={!isMinimum}>
            <div>
              {coPiDetailViewState &&
                <CoPiDetail
                  setViewState={setCoPiDetailViewState}
                  detailTargetId={detailTargetId}
                  planClickHandler={planClickHandler}
                />}
              {!coPiDetailViewState &&
                <>
                  <CoPiFilter/>
                  <CoPiTable planClickHandler={planClickHandler}/>
                </>
              }
            </div>
          </Collapse>
        </div>
      </div>
    </>
  )
});

const aircraftSortFunc = (a, b) => {
  const aTime = a.latest_obs_time ? a.latest_obs_time : '';
  const bTime = b.latest_obs_time ? b.latest_obs_time : '';
  if (aTime < bTime) {
    return 1;
  } else if (aTime > bTime) {
    return -1
  } else if (a.aircraft_code > b.aircraft_code) {
    return 1;
  } else if (a.aircraft_code < b.aircraft_code) {
    return -1;
  } else {
    return 0;
  }
};
const textFilter = ((item, searchText) => {
  if (!searchText) {
    return true;
  }
  return item.aircraft_code.toLowerCase().includes(searchText)
    || (!item.is_other_org ? item.aircraft_name.toLowerCase().includes(searchText) : item.aircraft_name_external.toLowerCase().includes(searchText));
});

const CoPiTable = memo((props) => {
  const {planClickHandler} = props;

  const classes = useStyles();
  const openMessageBoard = useSetRecoilState(messageWidgetVisibleState);
  const setSelectedGroup = useSetRecoilState(messageSelectedGroupState);
  const userGroup = useRecoilValue(userState).group;
  const messageNotAllowed = useRecoilValue(disabledContentsWithID(MESSAGE_WIDGET));
  const messageAircraftList = useRecoilValue(messageAircraftIds(userGroup));
  const {t} = useTranslation();
  const coPilotDisplaySettings = useRecoilValue(coPilotDisplaySettingsSelector);
  const [coPiListChecked, setCoPiListChecked] = useRecoilState(coPiListCheckedState);
  const [coPiAlertData, setCoPiAlertData] = useRecoilState(coPiAlertState);
  const coPiListData = useRecoilValue(coPiListDataState);
  const [page, setPage] = useState(0);
  const rowsPerPage = 50;
  const tableRef = useRef();
  const [searchText, setSearchText] = useState(null);
  const coPiSourceChecked = useRecoilValue(coPiSourceCheckedState);

  const sortedCoPiListData = useMemo(() => {
    setPage(0);

    const alertData = [];
    const within15Min = [];
    const moreThan15Min = [];

    const alertMap = new Map(coPiAlertData.map(alert => [alert.aircraft_code, alert]));

    coPiListData?.filter(d => textFilter(d, searchText)).forEach(d => {
      const alert = alertMap.get(d.aircraft_code);
      if (alert && alert.useCopiList && alert.alert_on) {
        alertData.push(d);
      } else if (d.is_within_15min) {
        within15Min.push(d);
      } else {
        moreThan15Min.push(d);
      }
    });
    alertData.sort(aircraftSortFunc);
    within15Min.sort(aircraftSortFunc);
    moreThan15Min.sort((a, b) => {
      if (a.aircraft_code > b.aircraft_code) {
        return 1;
      } else if (a.aircraft_code < b.aircraft_code) {
        return -1;
      } else {
        return 0;
      }
    });

    return [...alertData, ...within15Min, ...moreThan15Min]

  },[coPiListData, coPiAlertData, searchText]);


  // Detailボタン押下をDetail panelに通知する
  const setDetailTarget = useSetRecoilState(coPilotDetailTargetState);
  const detailClickHandler = (event, data) => {
    setDetailTarget(data);
    event.stopPropagation();
  }

  // Mapボタン押下をコンテンツに通知する
  const setFocusTarget = useSetRecoilState(coPilotFocusTargetState);
  const mapClickHandler = (event, data) => {
    setFocusTarget(data);
    event.stopPropagation();
  }

   // MessageBoardを展開する
  const messageClickHandler = (event, row) => {
    openMessageBoard(true);
    setSelectedGroup({aircraft: [row.aircraft_code], name: row.aircraft_code, type: 3});
    event.stopPropagation();
  }

  // CoPi表示
  const changeCheckHandler = name => {

    setCoPiListChecked(prev => {
      const newData = deepCopy(prev);
      const target = newData.find(data => data.aircraft_code === name);
      target.checked = !target.checked;
      return newData;
    });
  }

  // 行をクリック
  const rowClickHandler = (aircraft_code) => {
    setCoPiAlertData(prev => {
      const newData = deepCopy(prev);
      const targets = newData.filter(data => data.aircraft_code === aircraft_code);
      targets.forEach(t => t.confirmed = true);
      return newData;
    });
  }

  // AlertON/OFFクリック
  const alertClickHandler = (event, aircraft_code) => {
    event.stopPropagation();
    if (!coPilotDisplaySettings.alertNotification) return;
    setCoPiAlertData(prev => {
      const newData = deepCopy(prev);
      const target = newData.filter(data => data.aircraft_code === aircraft_code);
      target.forEach(t => t.alertSwitch = !t.alertSwitch);
      return newData;
    })
  }

  const handleChangePage = (_event, newPage) => {
    setPage(newPage -1);
    tableRef.current.scrollTop = 0;
  };

  const handleSearch = (searchText) => {
    setSearchText(searchText.toLowerCase());
  };

  const now = Date.now();
  const twoMinAgo = now - 2 * 60 * 1000;

  return (
    <>
    <TableContainer className={classes.tableContainer} ref={tableRef}>
      <Table stickyHeader size='small'>
        <TableBody>
          {sortedCoPiListData.slice(page * rowsPerPage, (page + 1) * rowsPerPage).map((row,index) => {
            const labelId = `enhanced-table-checkbox-${index}`;
            const checkedData = coPiListChecked?.find(data => data.aircraft_code === row.aircraft_code);
            const checked = checkedData ? checkedData.checked : false;

            // 行スタイルの設定
            let rowStyle;
            if (!rowStyle && index % 2 === 1) {
              rowStyle = TABLE_ROW_ODD_CLASS_NAME;
            }
            if (!row.is_within_15min) {
              rowStyle = TABLE_ROW_GRAY_CLASS_NAME;
            }
            const alert = coPiAlertData.find(d => d.aircraft_code === row.aircraft_code && d.useCopiList);
            if (alert?.alert_on) {
              if (twoMinAgo < alert.alert_reception_time && !alert.confirmed) {
                rowStyle = TABLE_ROW_ALERT_ANIME_CLASS_NAME;
              } else {
                rowStyle = TABLE_ROW_ALERT_CLASS_NAME;
              }
            }

            // 機体番号 or 愛称 or 他社表示名
            let displayName = row.aircraft_code;
            if (coPilotDisplaySettings.list === 'name') {
              if (!row.is_other_org) {
                displayName = row.aircraft_name;
              } else {
                displayName = row.aircraft_name_external;
              }
            }

            const messageDisabled = messageNotAllowed || !messageAircraftList.includes(row.aircraft_code);
            return (
              <TableRow
                key={labelId}
                className={rowStyle}
                hover
                onClick={() => rowClickHandler(row.aircraft_code)}
              >
                <TableCell padding="none" className={classes.checkbox}>
                  <Checkbox
                    checked={checked}
                    inputProps={{ 'aria-labelledby': labelId }}
                    size='small'
                    onChange={() => changeCheckHandler(row.aircraft_code)}
                  />
                </TableCell>
                <TableCell padding="none">
                  <div className={classes.imageBox}>
                    <img src={row.aircraft_image ? row.aircraft_image : noImage} className={classes.image} alt="aircraftImg" loading="lazy"/>
                  </div>
                </TableCell>
                <TableCell padding="none" className={classes.textCell}>
                  <div className={classes.infoCell}>
                    <div>
                      {![6, 7, 8, 9].includes(row.icon_id) && <div className={clsx(classes.iconCircle, classes.icon)}></div>}
                      {row.icon_id + '' === ID_HELI && <Heli className={clsx(classes.iconHeli, classes.icon)} />}
                      {row.icon_id + '' === ID_CESSNA && <Cessna className={clsx(classes.iconCessna, classes.icon)} />}
                      {row.icon_id + '' === ID_NAVI && <Navi className={clsx(classes.iconNavi, classes.icon)} />}
                      {row.icon_id + '' === ID_OTHER_COMPANY && <OtherCompany className={clsx(classes.iconOtherCompany, classes.icon)} />}
                    </div>
                    <div>
                      { displayName }
                    </div>
                  </div>
                  <div className={classes.infoCell}>
                    <Tooltip title={t('Map')}>
                      <RoomIcon fontSize="small" onClick={(event) => mapClickHandler(event, row.aircraft_code)} className={clsx(classes.clickableButton, classes.buttonIcon)} />
                    </Tooltip>
                    <Tooltip title={t('Detail')}>
                      <AssignmentIcon fontSize="small" onClick={(event) => detailClickHandler(event, row.aircraft_code)} className={clsx(classes.clickableButton, classes.buttonIcon)} />
                    </Tooltip>
                    <Tooltip title={t('Flight Plan')}>
                      <PlanWhite onClick={(event) => planClickHandler(event, row)} className={clsx(!row.is_other_org && row.flight_plan.find(p => p.is_current_plan) ? classes.clickableButton : classes.buttonIconDisabled, classes.buttonIcon, classes.planWhiteIcon)}/>
                    </Tooltip>
                    <Tooltip title={t('Message')}>
                      {!messageDisabled ?
                        <MailIcon fontSize="small" onClick={(event) => messageClickHandler(event, row)} className={clsx(classes.clickableButton, classes.buttonIcon)} color={'inherit'}/>
                        :
                        <MailIcon fontSize="small" className={classes.buttonIcon} color={'disabled'}/>
                      }
                    </Tooltip>
                    <Tooltip title={t('Sound Notification')}>
                      { coPilotDisplaySettings.alertNotification && alert?.alertSwitch ?
                        <VolumeOnIcon onClick={(event) => alertClickHandler(event, row.aircraft_code)} className={clsx(
                          coPilotDisplaySettings.alertNotification && classes.clickableButton, classes.alertEnabled, classes.buttonIcon
                        )}></VolumeOnIcon>
                        :
                        <VolumeOffIcon onClick={(event) => alertClickHandler(event, row.aircraft_code)} className={clsx(
                          coPilotDisplaySettings.alertNotification && classes.clickableButton, classes.alertEnabled, classes.buttonIcon,
                          !coPilotDisplaySettings.alertNotification && classes.buttonIconDisabled
                        )}></VolumeOffIcon>
                      }
                    </Tooltip>
                      {
                        coPiSourceChecked[row.aircraft_code] && Object.keys(coPiSourceChecked[row.aircraft_code]).some(c => !coPiSourceChecked[row.aircraft_code][c]) &&
                        <Tooltip title={t('Detail')}>
                          <Filter fontSize="small" onClick={(event) => detailClickHandler(event, row.aircraft_code)} className={clsx(classes.clickableButton, classes.buttonIcon)} />
                        </Tooltip>
                      }
                  </div>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
      <div style={{display: 'flex', justifyContent: 'space-between'}}>
        <SearchBar search={handleSearch}/>
        <Box style={{ display: 'flex', justifyContent: 'flex-end', padding: '2px', alignItems: 'baseline', fontSize: '0.875rem', width: 'max-content', flexShrink: 0}}>
          <div>{`${page * rowsPerPage + 1} - ${Math.min((page + 1) * rowsPerPage, sortedCoPiListData.length)} / ${sortedCoPiListData.length}`}</div>
          <Pagination
            page={page+1}
            count={Math.ceil(sortedCoPiListData.length / rowsPerPage)}
            onChange={handleChangePage}
            size='small'
            showFirstButton
            showLastButton
          />
        </Box>
      </div>
    </>
  )
});

const useSearchBarStyles = makeStyles((theme) => ({
  root: {},
  search: {
    position: 'relative',
    backgroundColor: alpha(theme.palette.common.black, 0.08),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.black, 0.15),
    },
    marginLeft: 0,
    width: '100%',
    height: 30
  },
  searchIcon: {
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
  },
  inputInput: {
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(4),
    width: '100%'
  }
}));

const SearchBar = ({search}) => {
  const classes = useSearchBarStyles();
  return (
    <div className={classes.root}>
      <div className={classes.search}>
        <div className={classes.searchIcon}>
          <Search/>
        </div>
        <Input
          placeholder="Search…"
          autoFocus={true}
          disableUnderline
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
          }}
          inputProps={{spellCheck: false}}
          onChange={(event) => search(event.target.value)}
        />
      </div>
    </div>
  );
};

const Pagination = withStyles({
  ul: {
    "&>li": {
      display: 'none'
    },
    "&>li:nth-of-type(1)": {
      display: 'block'
    },
    "&>li:nth-of-type(2)": {
      display: 'block'
    },
    "&>li:nth-last-of-type(1)": {
      display: 'block'
    },
    "&>li:nth-last-of-type(2)": {
      display: 'block'
    },

  }
})(MuiPagination);

const StyledFormControlLabel = withStyles({
  root: {
    marginRight: 12
  }
})(FormControlLabel);

function SelectCheckboxList() {
  const classes = useStyles();
  const [coPiListChecked, setCoPiListChecked] = useRecoilState(coPiListCheckedState);
  const coPiListData = useRecoilValue(coPiListDataState);
  const [aircraftGroup, setAircraftGroup] = useState([]);
  const [open, setOpen] = useState(false);
  const [list, setList] = useState();

  useEffect(() => {
    const tmepData = {};
    coPiListData?.forEach(d => {
      d.linked_aircraftgroup.forEach(g => {
        if (tmepData[g.aircraftgroup_name]) {
          tmepData[g.aircraftgroup_name].push(d.aircraft_code);
        } else {
          tmepData[g.aircraftgroup_name] = [d.aircraft_code];
        }
      })
    });
    setAircraftGroup(Object.entries(tmepData).sort((a, b) => {
      if (a[0] > b[0]) return 1;
      if (a[0] < b[0]) return -1;
      return 0;
    }).map(d => {return {groupName: d[0], aircraft: d[1]}}));
  }, [coPiListData]);

  useEffect(() => {
    const newData = aircraftGroup.map(d => {
      const targets = (coPiListChecked || []).filter(c => d.aircraft.includes(c.aircraft_code));
      const checked = targets.find(target => target.checked) ? true : false;
      return {...d, ...{checked: checked, displayNone: !targets.length}};
    })
    setList(newData);
  }, [aircraftGroup, coPiListChecked]);

  const handleClickIconButton = () => {
    setOpen(prev => !prev);
  }
  const handleClickAway = () => {
    setOpen(false);
  }
  const handleCheckboxChange = (event, aircraft) => {
    setCoPiListChecked(prev => {
      const newData = deepCopy(prev);
      const targets = newData.filter(d => aircraft.includes(d.aircraft_code));
      targets.forEach(t => {
        t.checked = event.target.checked;
      });
      return newData;
    });
  }

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div>
        <Tooltip title=''>
          <IconButton onClick={handleClickIconButton} className={classes.groupFilterButton}>
            <FilterListIcon/>
          </IconButton>
        </Tooltip>
        {
          open ? (
            <div className={classes.groupFilterList}>
              <List dense>
                {list.map((row, index) => {
                  return (
                    <ListItem dense key={`SelectCheckboxList-${row.groupName}-${index}`} className={clsx(row.displayNone && classes.displayNone)}>
                      <ListItemIcon>
                        <Checkbox checked={row.checked} onChange={(e) => handleCheckboxChange(e, row.aircraft)} size='small'></Checkbox>
                      </ListItemIcon>
                      <ListItemText>{row.groupName}</ListItemText>
                    </ListItem>
                  )
                })}
              </List>
            </div>
          ) : null
        }
      </div>
    </ClickAwayListener>
  )
}

function CoPiFilter() {
  const classes = useStyles();
  const {t} = useTranslation();
  const [coPiListChecked, setCoPiListChecked] = useRecoilState(coPiListCheckedState);
  const [filterTarget, setFilterTarget] = useState({...DEFAULT_FILTER_TARGET});
  const [filterDisabled, setFilterDisabled] = useState({...DEFAULT_FILTER_DISABLED});

  useEffect(() => {
    let heliChecked = true;
    let cessnaChecked = true;
    let naviChecked = true;
    let otherCompanyChecked = true;
    let otherChecked = true;
    let heliCount = 0;
    let cessnaCount = 0;
    let naviCount = 0;
    let otherCompanyCount = 0;
    let otherCount = 0;
    coPiListChecked?.forEach(c => {
      switch(c.icon_id + '') {
        case ID_HELI:
          heliCount++;
          if (!c.checked) heliChecked = false;
          break;
        case ID_CESSNA:
          cessnaCount++;
          if (!c.checked) cessnaChecked = false;
          break;
        case ID_NAVI:
          naviCount++;
          if (!c.checked) naviChecked = false;
          break;
        case ID_OTHER_COMPANY:
          otherCompanyCount++;
          if (!c.checked) otherCompanyChecked = false;
          break;
        default:
          otherCount++;
          if (!c.checked) otherChecked = false;
          break;
      }
    });

    const all = heliChecked && cessnaChecked && naviChecked && otherCompanyChecked && otherChecked;

    setFilterTarget({
      all: all,
      heli: heliChecked,
      cessna: cessnaChecked,
      navi: naviChecked,
      otherCompany: otherCompanyChecked,
      other: otherChecked
    });

    setFilterDisabled({
      heli: !heliCount,
      cessna: !cessnaCount,
      navi: !naviCount,
      otherCompany: !otherCompanyCount,
      other: !otherCount
    });
  }, [coPiListChecked]);

  const handleFilterChange = event => {
    const id = event.target.name;
    const checked = event.target.checked;

    setCoPiListChecked(prev => {
      const newData = deepCopy(prev);
      newData.forEach(d => {
        if (id === ID_ALL) {
          d.checked = checked;
        } else if (id === d.icon_id + '') {
          d.checked = checked;
        } else if (id === ID_OTHER && ![6, 7, 8, 9].includes(d.icon_id)) {
          d.checked = checked;
        }
      });
      return newData;
    });
  }

  return (
    <div className={classes.coPiFilter}>
      <FormGroup row>
        <StyledFormControlLabel
          control={<Checkbox className={classes.filterCheckBox} checked={filterTarget.all} onChange={handleFilterChange} name={ID_ALL} size='small' />}
          label={<span className={classes.inputLabel}>{t('All')}</span>}
        />
        <Tooltip title={t('Heli')}>
          <StyledFormControlLabel
            control={<Checkbox className={classes.filterCheckBox} checked={filterTarget.heli} onChange={handleFilterChange} name={ID_HELI} size='small' disabled={filterDisabled.heli} />}
            label={<>
              <Heli className={clsx(classes.iconHeli, classes.icon)} />
            </>}
          />
        </Tooltip>
        <Tooltip title={t('Cessna')}>
          <StyledFormControlLabel
            control={<Checkbox className={classes.filterCheckBox} checked={filterTarget.cessna} onChange={handleFilterChange} name={ID_CESSNA} size='small' disabled={filterDisabled.cessna} />}
            label={<>
              <Cessna className={clsx(classes.iconCessna, classes.icon)} />
            </>}
          />
        </Tooltip>
        <Tooltip title={t('Navi')}>
          <StyledFormControlLabel
            control={<Checkbox className={classes.filterCheckBox} checked={filterTarget.navi} onChange={handleFilterChange} name={ID_NAVI} size='small' disabled={filterDisabled.navi} />}
            label={<>
              <Navi className={clsx(classes.iconNavi, classes.icon)} />
            </>}
          />
        </Tooltip>
        <Tooltip title={t('Other Company')}>
          <StyledFormControlLabel
            control={<Checkbox className={classes.filterCheckBox} checked={filterTarget.otherCompany} onChange={handleFilterChange} name={ID_OTHER_COMPANY} size='small' disabled={filterDisabled.otherCompany} />}
            label={<>
              <OtherCompany className={clsx(classes.iconOtherCompany, classes.icon)}></OtherCompany>
            </>}
          />
        </Tooltip>
        <Tooltip title={t('Other')}>
          <StyledFormControlLabel
            control={<Checkbox className={classes.filterCheckBox} checked={filterTarget.other} onChange={handleFilterChange} name={ID_OTHER} size='small' disabled={filterDisabled.other} />}
            label={<div className={clsx(classes.iconCircle, classes.icon)}></div>}
            classes={{root: classes.root}}
          />
        </Tooltip>
      </FormGroup>
      <SelectCheckboxList/>
    </div>
  );
}

const CustomButton = withStyles({
  sizeSmall: {
    fontSize: '11px',
    width: 128
  }
})(Button);

const NO_RECORD = '---';
const MASK_STR = '*****';

const CoPiDetail = memo((props) => {
  const {setViewState, detailTargetId, planClickHandler} = props;
  const coPiListData = useRecoilValue(coPiListDataState);
  const [messageBoard, openMessageBoard] = useRecoilState(messageWidgetVisibleState);
  const [selectedGroup, setSelectedGroup] = useRecoilState(messageSelectedGroupState);
  const userGroup = useRecoilValue(userState).group;
  const messageNotAllowed = useRecoilValue(disabledContentsWithID(MESSAGE_WIDGET));
  const messageAircraftList = useRecoilValue(messageAircraftIds(userGroup));
  const setDetailTargetId = useSetRecoilState(coPilotDetailTargetState);
  const classes = useStyles();
  const {t} = useTranslation();
  const timeZone = useRecoilValue(timeZoneSelector);
  const {isCoPilotType, setCsTypeCoPilot, clearCsType} = useCrossSectionData();
  const [coPiSourceChecked, setCoPiSourceChecked] = useRecoilState(coPiSourceCheckedState);
  const tooltipSettings = useRecoilValue(coPiTooltipSettings);
  const {linkableSourceList} = useLinkableSourceList();

  const detailData = coPiListData?.find(coPi => coPi.aircraft_code === detailTargetId);

  const onCloseHandler = () => {
    setDetailTargetId('');
    setViewState(false);
  }

  // Messageボタン
  const [messageSelected, setMessageSelected] = useState('default');
  useEffect(() => {
    if (selectedGroup?.aircraft?.find(aircraft => aircraft === detailTargetId) && messageBoard) {
      setMessageSelected('primary');
    } else {
      setMessageSelected('default');
    }
  }, [selectedGroup, setMessageSelected, detailTargetId, messageBoard]);
  const handleMessageButton = (aircraft_code) => {

    if (messageSelected === 'default') {
      openMessageBoard(true);
      setSelectedGroup({aircraft: [aircraft_code], name: aircraft_code, type: 3});
    } else {
      openMessageBoard(false);
    }
  }

  // CrossSectionボタン
  const [csSelected, setCsSelected] = useState('default');
  const { changeHorizontal, changeMapOnly, isMapOnly } = useLayoutState();
  const [csTarget, setCsTargetState] = useRecoilState(csTargetState);
  const setCsGradation = useSetRecoilState(csGradationState);
  const setCsAdjustVerticalZoomWithRoute = useSetRecoilState(csAdjustVerticalZoomWithRouteSelector);
  const setCsTargetSelectState = useSetRecoilState(csTargetSelectState);

  useEffect(() => {
    if (isCoPilotType && csTarget.id === detailTargetId) {
      setCsSelected('primary');
    } else {
      setCsSelected('default');
    }
  }, [isCoPilotType, csTarget, detailTargetId, setCsSelected]);
  const handleCsButton = () => {
    const targetId = csSelected === 'default' ? detailTargetId : '';
    if (targetId && detailData.sources.length > 1) {
      setCsTargetSelectState(targetId);
      return;
    }
    setCsAdjustVerticalZoomWithRoute(prev => {
      return {...prev, ...{adjust: true, update: false}};
    });
    setCsGradation(true);
    setCsTargetState({id: targetId, dataSourceId: detailData.sources[0]?.data_source_id});
    if (targetId !== '') {
      setCsTypeCoPilot(detailData.aircraft_code, detailData.aircraft_name);
      if (isMapOnly) {
        changeHorizontal();
      }
    } else {
      clearCsType();
      changeMapOnly();
    }
  };

  // nav logボタン
  const [navLogSelected, setNavLogSelected] = useState('default');
  const [navLogTarget, setNavLogTarget] = useRecoilState(navLogTargetState);
  useEffect(() => {
    if (navLogTarget === detailTargetId) {
      setNavLogSelected('primary');
    } else {
      setNavLogSelected('default');
    }
  }, [navLogTarget, setNavLogSelected, detailTargetId]);

  const handleNavLogButton = (targetId) => {
    if (navLogSelected === 'default') {
      setNavLogTarget(targetId);
    } else {
      setNavLogTarget('');
    }
  }

  // active alertボタン
  const [alertSelected, setAlertSelected] = useState('default');
  const [alertTarget, setAlertTarget] = useRecoilState(activeAlertTargetState);
  useEffect(() => {
    if (alertTarget === detailTargetId) {
      setAlertSelected('primary');
    } else {
      setAlertSelected('default');
    }
  }, [alertTarget, setAlertSelected, detailTargetId]);
  const handleActiveAlertsButton = (targetId) => {
    if (alertSelected === 'default') {
      setAlertTarget(targetId);
    } else {
      setAlertTarget('');
    }
  }

  // Sourceの選択状態
  const handleChangeVisible = (code, source) => {
    setCoPiSourceChecked(prev => {
      const newData = deepCopy(prev);
      newData[code][source] = !newData[code][source];
      return newData;
    });
  }

  const _batteryValue2Str = useCallback((code) => {
    let ret = '-';
    if (code <= 3) {
      ret = 'Empty'
    } else if (code <= 3.5) {
      ret = 'Good';
    } else if (code < 4.8) {
      ret = 'Full';
    }
    return ret;
  }, []);

  const plan = detailData.flight_plan?.find(p => p.is_current_plan);
  const timeZoneStr = formatTimeZoneStr(timeZone);

  let sbdImei = NO_RECORD;
  let remarks = NO_RECORD;
  let dep = NO_RECORD;
  let arr = NO_RECORD;
  let etd = NO_RECORD;
  let eta = NO_RECORD;
  let sta = NO_RECORD;
  let buttonDisabled = false;
  const latestDataSourceId = detailData.sources.find(s => s.is_latest)?.data_source_id;
  const dataSourceName = linkableSourceList.find(l => l.data_source_id === latestDataSourceId)?.data_source_name;
  const latestPositionData = {
    "%conv_latest_obs_time%": detailData.latest_obs_time ? formatTimeZoneDate(detailData.latest_obs_time) : NO_RECORD,
    "%conv_source%": dataSourceName ? dataSourceName : NO_RECORD,
    "%conv_alt_ft%": typeof detailData.alt_ft === "number" ? Math.round(detailData.alt_ft * 100) / 100 : NO_RECORD,
    "%conv_lat%": detailData.lat ? formatLatDM(detailData.lat) : NO_RECORD,
    "%conv_lon%": detailData.lon ? formatLonDM(detailData.lon) : NO_RECORD,
    "%conv_voltage%": typeof detailData.voltage === "number" ? _batteryValue2Str(detailData.voltage) : NO_RECORD
  }
  const latestPositionDataList = tooltipSettings[latestDataSourceId]?.["CoPilot-detail"].map(s => {
    const keys = s.value.match(/%\w+%/g);
    let value = s.value;
    keys.forEach(key => {
      const convValue = latestPositionData[key];
      if (convValue !== undefined) {
        value = value.replace(key, convValue);
      } else {
        const rowValue = detailData[key.replace(/%/g, "")];
        value = value.replace(key, rowValue !== null && rowValue !== undefined ? rowValue : NO_RECORD);
      }
    });
    return {...s, ...{value: value}};
  });

  if (detailData.is_other_org) {
    sbdImei = MASK_STR;
    remarks = MASK_STR;
    dep = MASK_STR;
    arr = MASK_STR;
    etd = MASK_STR;
    eta = MASK_STR;
    buttonDisabled = true;
  } else {
    if (detailData.sbd_imei !== null) {
      sbdImei = detailData.sbd_imei;
    }

    if (detailData.remarks !== null) {
      remarks = detailData.remarks;
    }

    if (plan) {
      if (plan.dep_point_name) {
        dep = plan.dep_point_name;
      }
      if (plan.arr_point_name) {
        arr = plan.arr_point_name;
      }
      if (plan.etd_utc) {
        etd = `${formatTimeZoneDate(plan.etd_utc, timeZone, 'HH:mm')} ${timeZoneStr}`;
      }
      if (plan.eta_utc) {
        eta = `${formatTimeZoneDate(plan.eta_utc, timeZone, 'HH:mm')} ${timeZoneStr}`;
      } else if (plan.sta_utc) {
        sta = `${formatTimeZoneDate(plan.sta_utc, timeZone, 'HH:mm')} ${timeZoneStr}`;
      }
    }
  }

  //Messageボタン非活性
  const messageDisabled = messageNotAllowed || !messageAircraftList.includes(detailTargetId);

  return (
    <>
      <div className={classes.detailBox}>
        <div className={clsx(classes.displayFlex, classes.detailTitle, classes.detailSection)}>
          <div className={classes.displayFlex}>
            <div className={classes.detailAircraftName}>{detailData.aircraft_code}</div>
            <div>{`(${!detailData.is_other_org ? detailData.aircraft_name : detailData.aircraft_name_external})`}</div>
          </div>
          <div>
            <CloseIcon onClick={onCloseHandler} fontSize='small' className={classes.closeIcon}></CloseIcon>
          </div>
        </div>
        <div className={clsx(classes.displayFlex, classes.detailSection)}>
          <div className={classes.detailAirCraftImgBox}>
            <img src={detailData.aircraft_image ? detailData.aircraft_image : noImage} className={classes.detailAirCraftImg} alt="aircraftImg" />
          </div>
          <div className={classes.positionDataSection}>
            <div>Latest position data</div>
            {
              latestDataSourceId ? (
                <List dense={true} className={classes.positionData}>
                  {
                    latestPositionDataList?.map(d => {
                      return (
                        <ListItem className={classes.listItem} key={d.label}>
                          <ListItemText className={classes.listItemText}>
                            <div className={classes.listItemTextChild}>
                              <div className={classes.itemName}>{d.label}</div>
                              <div className={classes.detailSeparator}>:</div>
                              <div>{d.value}</div>
                            </div>
                          </ListItemText>
                        </ListItem>
                      )
                    })
                  }
                </List>
              ) : (
                <List dense={true} className={classes.positionData}>
                  <ListItem className={classes.listItem}>
                    <ListItemText className={classes.listItemText}>
                      <div>{t('no position data')}</div>
                    </ListItemText>
                  </ListItem>
                </List>
              )
            }
          </div>
        </div>
        <div className={clsx(classes.detailSection)}>
          <div>Aircraft data</div>
          <List dense={true} className={classes.aircraftData}>
            {
              (detailData.sbd_imei || detailData.sources.find(s => s.data_source_id === linkableSourceList[0]?.data_source_id)) &&
              <ListItem className={classes.listItem}>
                <ListItemText className={classes.listItemText}>
                  <div className={classes.listItemTextChild}>
                    <div className={classes.sourceName}>{linkableSourceList[0]?.data_source_name}</div>
                    <div className={classes.detailSeparator}>:</div>
                    <div>{sbdImei}</div>
                  </div>
                </ListItemText>
                <div className={classes.showSwitch}>
                  <TinySwitch checked={coPiSourceChecked[detailData.aircraft_code][linkableSourceList[0]?.data_source_id]} onChange={(e) => handleChangeVisible(detailData.aircraft_code, linkableSourceList[0]?.data_source_id)} />
                  <div className={classes.showSwitchLabel}>{t('Show')}</div>
                </div>
              </ListItem>
            }
            {
              detailData.sources.filter(s => {
                if (s.data_source_id !== linkableSourceList[0]?.data_source_id && coPiSourceChecked[detailData.aircraft_code][s.data_source_id] !== undefined) {
                  return true;
                }
                return false;
              }).map((s, i) => {
                return (
                  <ListItem className={classes.listItem} key={s.data_source_id}>
                    <ListItemText className={classes.listItemText}>
                      <div className={classes.listItemTextChild}>
                        <div className={classes.sourceName}>{linkableSourceList.find(l => l.data_source_id === s.data_source_id)?.data_source_name}</div>
                        <div className={classes.detailSeparator}>:</div>
                        <div>available</div>
                      </div>
                    </ListItemText>
                    <div className={classes.showSwitch}>
                      <TinySwitch checked={coPiSourceChecked[detailData.aircraft_code][s.data_source_id]} onChange={(e) => handleChangeVisible(detailData.aircraft_code, s.data_source_id)} />
                      <div className={classes.showSwitchLabel}>{t('Show')}</div>
                    </div>
                  </ListItem>
                )
              })
            }
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText}>
                <div className={classes.listItemTextChild}>
                  <div className={classes.itemName}>Model</div>
                  <div className={classes.detailSeparator}>:</div>
                  <div>{detailData.model ? detailData.model : NO_RECORD}</div>
                </div>
              </ListItemText>
            </ListItem>
            <ListItem className={classes.listItem}>
            <ListItemText className={classes.listItemText}>
              <div className={classes.listItemTextChild}>
                <div className={classes.itemName}>Base</div>
                <div className={classes.detailSeparator}>:</div>
                <div>{detailData.base ? detailData.base : NO_RECORD}</div>
              </div>
            </ListItemText>
            </ListItem>
            <ListItem className={classes.listItem}>
            <ListItemText className={classes.listItemText}>
              <div className={classes.listItemTextChild}>
                <div className={classes.itemName}>Remarks</div>
                <div className={classes.detailSeparator}>:</div>
                <div className={classes.remarks}>{remarks}</div>
              </div>
            </ListItemText>
            </ListItem>
          </List>
        </div>
        <div className={classes.detailSection}>
          <div>
            <div className={clsx(classes.displayFlex, classes.spaceBetween)}>
              <div className={clsx(classes.displayFlex, classes.detailDepArrInner)}>
                <div>DEP</div>
                <div>{dep}</div>
              </div>
              <div className={clsx(classes.displayFlex, classes.detailDepArrInner)}>
                <div>ARR</div>
                <div>{arr}</div>
              </div>
            </div>
          </div>
          <div>
            <div className={clsx(classes.displayFlex, classes.spaceBetween)}>
              <div className={clsx(classes.displayFlex, classes.detailDepArrInner)}>
                <div>ETD</div>
                <div>{etd}</div>
              </div>
              <div className={clsx(classes.displayFlex, classes.detailDepArrInner)}>
                <div>{eta === NO_RECORD && sta !== NO_RECORD ? 'STA' : 'ETA'}</div>
                <div>{eta === NO_RECORD && sta !== NO_RECORD ? sta : eta}</div>
              </div>
            </div>
          </div>
        </div>
        <div className={clsx(classes.displayFlex, classes.detailSection, classes.planDetail, !plan && classes.displayNone)} onClick={event => planClickHandler(event, detailData)}>
          {t('Plan detail')}
        </div>
        <div className={clsx(classes.displayFlex, classes.detailSection, classes.buttonPosition)}>
          <CustomButton color={csSelected} variant="contained" size="small" startIcon={<ImageCrossSection className={clsx(classes.csButtonIcon, csSelected === "default" ? classes.defaultCsButtonIcon : classes.primaryCsButtonIcon)} />} onClick={handleCsButton}>
            {t('Cross section')}
          </CustomButton>
          <div className={classes.detailSeparator}></div>
          <CustomButton color={navLogSelected} variant="contained" size="small" startIcon={<HistoryIcon />} onClick={() => handleNavLogButton(detailData.aircraft_code)} disabled={buttonDisabled}>
            {t('NAV LOG')}
          </CustomButton>
        </div>
        <div className={clsx(classes.displayFlex, classes.detailSection, classes.buttonPosition)}>
          <CustomButton color={alertSelected} variant="contained" size="small" startIcon={<NotificationsActiveIcon />} onClick={() => handleActiveAlertsButton(detailData.aircraft_code)} disabled={buttonDisabled}>
            {t('Active Alerts')}
          </CustomButton>
          <div className={classes.detailSeparator}></div>
          <CustomButton color={messageSelected} variant="contained" size="small" startIcon={<MailIcon />} onClick={() => handleMessageButton(detailData.aircraft_code)} disabled={buttonDisabled || messageDisabled}>
            {t('Message')}
          </CustomButton>
        </div>
      </div>
    </>
  );
});

function RingAlert() {
  const ctx = useRecoilValue(audioContextState);
  const [alertType, setAlertType] = useState(ALERT_TYPE_DEFAULT);
  const connected = useRef(false);
  const coPilotDisplaySettings = useRecoilValue(coPilotDisplaySettingsSelector);
  const coPilotVisible = useRecoilValue(mapContentsVisibleWithID(MAP_ID_COPILOT));

  useEffect(() => {
    setAlertType(ALERT_TYPE_DEFAULT);
  }, []);

  const connects = useCallback(() => {
    gain.connect(ctx.destination);
    dry.connect(gain);
    delay.connect(wet);
    wet.connect(gain);
    delay.connect(feedback);
    feedback.connect(delay);
    connected.current = true;
  }, [ctx]);

  const changeAlertSetting = useCallback((type) => {
    if (!ctx) return;
    const soundSetting = ALERT_SOUND_SETTINGS[type];
    if (!gain) {
      gain = ctx.createGain();
    }
    gain.gain.value = soundSetting.gain;
    if (!dry) {
      dry = ctx.createGain();
    }
    dry.gain.value = soundSetting.dry;
    if (!wet) {
      wet = ctx.createGain();
    }
    wet.gain.value = soundSetting.wet;
    if (!feedback) {
      feedback = ctx.createGain();
    }
    feedback.gain.value = soundSetting.feedback;
    if (!delay) {
      delay = ctx.createDelay(1);
    }
    delay.delayTime.value = soundSetting.delay;
    if (!connected.current) {
      connects();
    }
  }, [ctx, connects]);

  const intervalId = useRef();
  const timeoutId = useRef();
  const ringAlert = useCallback(() => {
    if (!ctx) return;
    const soundSetting = ALERT_SOUND_SETTINGS[alertType];
    const oneCycleAlert = () => {
      const oscillator = ctx.createOscillator();
      oscillator.type = soundSetting.type;
      oscillator.frequency.value = soundSetting.frequency;
      if (!dry) {
        changeAlertSetting(alertType);
      }
      oscillator.connect(dry);
      oscillator.connect(delay);
      oscillator.start(0);
      oscillator.stop(ctx.currentTime + soundSetting.stopTiming);
    }
    oneCycleAlert();
    intervalId.current = setInterval(oneCycleAlert, soundSetting.interval);
    clearAlertTimeout();
    timeoutId.current = setTimeout(() => {
      clearInterval(intervalId.current);
      intervalId.current = undefined;
    }, 2 * 60 * 1000);
  }, [alertType, ctx, changeAlertSetting]);

  const stopAlert = useCallback(() => {
    if (intervalId.current) {
      clearInterval(intervalId.current);
      intervalId.current = undefined;
    }
    clearAlertTimeout();
  }, []);

  const clearAlertTimeout = (() => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
      timeoutId.current = undefined;
    }
  });

  const alerts = useRecoilValue(coPiAlertState);
  useEffect(() => {
    if (!coPilotDisplaySettings.alertNotification || !coPilotVisible) {
      stopAlert();
    } else {
      // alertが発生していて、行クリックで点滅が止まってない、個別のAlertONのCoPiの最新のAlert受信時刻を取得
      let latestTime = RINGING_TIME;
      const targets = alerts.filter(a => !a.confirmed && a.alert_on && a.useCopiList && a.alertSwitch);
      if (0 < targets.length) {
        latestTime = targets.reduce((a, b) => {
          if (a.alert_reception_time > b.alert_reception_time) {
            return a;
          } else {
            return b;
          }
        }).alert_reception_time;
      }

      // 現在時刻との差が2分以内だったら音を鳴らす
      const diff = Date.now() - latestTime;
      if (diff < RINGING_TIME) {
        if (!intervalId.current) {
          ringAlert();
        }
      } else {
        stopAlert();
      }
    }

  }, [alerts, ringAlert, stopAlert, coPilotDisplaySettings.alertNotification, coPilotVisible]);

  useEffect(() => {
    changeAlertSetting(alertType);
  }, [alertType, changeAlertSetting])

  useEffect(() => {
    return () => {
      stopAlert();
    }
    // eslint-disable-next-line
  }, []);

  return null;
}

export default CoPilotList;
